module.exports = __webpack_public_path__ + "static/media/duplicatedPig.adc5984b.svg";